import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useRef } from 'react';
import { POSITIONS } from "../../../tooltip/src";
import { TinyMceEditorComponent as TinyMCEEditor } from './TinyMceEditorComponent';
import { BaseInput } from '../BaseInput';
export const TinyMCEInput = forwardRef((_a, ref) => {
    var { init, onInit, tinymceScriptSrc, width = '100%' } = _a, props = __rest(_a, ["init", "onInit", "tinymceScriptSrc", "width"]);
    const refFallback = useRef(null);
    const actualRef = ref || refFallback;
    return (_jsx(BaseInput, Object.assign({}, props, { inputComponent: TinyMCEEditor, inputProps: {
            init,
            onInit,
            tinymceScriptSrc,
        }, onLabelClick: () => { var _a; return (_a = actualRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, ref: actualRef, tooltipPosition: POSITIONS.BOTTOM, width: width })));
});
//# sourceMappingURL=index.js.map